import { render, staticRenderFns } from "./MusicContent.vue?vue&type=template&id=7831c1cc"
import script from "./MusicContent.vue?vue&type=script&lang=js"
export * from "./MusicContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports